function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDefectInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M10.33,1.64A2.33,2.33,0,0,1,9.65.54.77.77,0,1,0,8.18,1,3.9,3.9,0,0,0,9.1,2.6,3.57,3.57,0,0,1,10.33,1.64Z",
    style: {
      fill: "#d2e1fa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2,21.19a.77.77,0,1,0,1.47.46,3.58,3.58,0,0,1,2-2.34A8.62,8.62,0,0,1,5,17.79,5.11,5.11,0,0,0,2,21.19Z",
    style: {
      fill: "#d2e1fa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.5,5.7a.77.77,0,0,0-1-.5.77.77,0,0,0-.5,1A5.17,5.17,0,0,0,5.46,9.3c.13-.53.27-1.07.43-1.59A3.77,3.77,0,0,1,4.5,5.7Z",
    style: {
      fill: "#d2e1fa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.69,10.47a.78.78,0,0,0-1,1.15,5.28,5.28,0,0,0,3.22,1.47c0-.51.1-1,.17-1.54A3.68,3.68,0,0,1,2.69,10.47Z",
    style: {
      fill: "#d2e1fa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22,21.19a5.39,5.39,0,0,0-1.89-2.79,4.7,4.7,0,0,0-1.1-.61,8.49,8.49,0,0,1-.45,1.51,3.36,3.36,0,0,1,1.55,1.39,5.33,5.33,0,0,1,.42,1A.77.77,0,1,0,22,21.19Z",
    style: {
      fill: "#d2e1fa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.65.26a.75.75,0,0,0-1.13,0,.88.88,0,0,0-.17.28,2.33,2.33,0,0,1-.68,1.1,3.57,3.57,0,0,1,1.23,1A3.9,3.9,0,0,0,15.82,1,.75.75,0,0,0,15.65.26Z",
    style: {
      fill: "#d2e1fa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4,10.57a.77.77,0,0,0-1.09,0,4.57,4.57,0,0,1-1.2.8A3.12,3.12,0,0,1,19,11.6c.07.51.12,1,.15,1.54a4.61,4.61,0,0,0,1-.17,5.66,5.66,0,0,0,2.24-1.3A.79.79,0,0,0,22.4,10.57Z",
    style: {
      fill: "#d2e1fa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.47,5.2a.74.74,0,0,0-.36,0,.77.77,0,0,0-.61.52,3.81,3.81,0,0,1-1.37,2c.17.53.31,1.06.44,1.59a5,5,0,0,0,1.54-1.38A6.15,6.15,0,0,0,21,6.17.77.77,0,0,0,20.47,5.2Z",
    style: {
      fill: "#d2e1fa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.31,6.45q-.22.63-.42,1.26c-.16.52-.3,1.06-.43,1.59-.17.74-.32,1.5-.42,2.25-.07.51-.13,1-.17,1.54a25.17,25.17,0,0,0,0,2.88l0,.59A9.84,9.84,0,0,0,5,17.79a8.62,8.62,0,0,0,.46,1.52A7.94,7.94,0,0,0,10.37,24l.11,0a.61.61,0,0,0,.68-.54l.84-6.9h0V7.73h0A13.25,13.25,0,0,1,6.31,6.45Z",
    style: {
      fill: "#d2e1fa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,1.29a3.92,3.92,0,0,0-1.67.35,3.57,3.57,0,0,0-1.23,1A7.88,7.88,0,0,0,7.85,4.83l-.1.29A8.18,8.18,0,0,0,12,6.3h0v-5Z",
    style: {
      fill: "#d2e1fa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.15,13.14c0-.52-.08-1-.15-1.54a20,20,0,0,0-.43-2.31c-.13-.53-.27-1.06-.44-1.59s-.28-.83-.44-1.25A13.29,13.29,0,0,1,12,7.73v8.83l.83,6.9,0,.11a.61.61,0,0,0,.76.4,7.92,7.92,0,0,0,4.94-4.67A8.49,8.49,0,0,0,19,17.79a8.27,8.27,0,0,0,.15-1.23l0-.59A26.57,26.57,0,0,0,19.15,13.14Z",
    style: {
      fill: "#b4cefa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.14,4.83A7.63,7.63,0,0,0,14.9,2.6a3.57,3.57,0,0,0-1.23-1A3.92,3.92,0,0,0,12,1.29v5a8.18,8.18,0,0,0,4.25-1.18Z",
    style: {
      fill: "#b4cefa"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefectInactive);
export default __webpack_public_path__ + "static/media/defect_inactive.cdc33b21edef27d965cc3cfa7c768494.svg";
export { ForwardRef as ReactComponent };